/* eslint-disable camelcase */
import { Platform } from "react-native";
import _ from 'lodash';
import Builder from 'react-native-jala-orm/src/model/Builder';
import QueryBuilder from 'react-native-jala-orm/src/query/Builder';
import Expression from 'react-native-jala-orm/src/query/Expression';
import Farm from './Farm';
import Cycle from './Cycle';
import SyncableModel from './SyncableModel';
import moment from "moment";

export default class Batch extends SyncableModel {
    static name = 'Batch'

    _table = 'batches'

    incrementing = false

    _keyType = 'string'

    static syncOnly = true

    static hasSyncedAt = false

    static endpoint = '/batches'

    static searchables = ['start_batch']

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }

        const fromQuery = this._getFromQuery();
        query.table(new Expression(`(${fromQuery.toSql()}) as ${query.getModel().getTable()}`));
        query.getQuery().bindings.join = [
          ...fromQuery.getBindings(),
          ...query.getQuery().bindings.join
        ];
      });
    }

    static _getFromQuery() {
      const batchStart = new Cycle().setTable('batches_start');
      const batchStartRow = new Cycle().setTable('batches_start_row');
      const batchStartRow0 = new Cycle().setTable('batches_start_row0');
      const batchStartQuery = Cycle.query().setModel(batchStart).withoutGlobalScopes(['join_batch'])
        .select([
          new Expression(`(${batchStart.qualifyColumn('farm_id')} || ',' || ${batchStart.qualifyColumn('started_at')}) as id`),
          new Expression(`(${
            Cycle.query().setModel(batchStartRow)
              .selectRaw('COUNT(*)')
              .table(new Cycle().getTable(), batchStartRow.getTable())
              .whereColumn(batchStartRow.qualifyColumn('farm_id'), batchStart.qualifyColumn('farm_id'))
              .whereColumn(batchStartRow.qualifyColumn('started_at'), '<=', batchStart.qualifyColumn('started_at'))
              .addWhereExistsQuery(
                Cycle.query().setModel(batchStartRow0).withoutGlobalScopes(['join_batch'])
                  .table(new Cycle().getTable(), batchStartRow0.getTable())
                  .whereColumn(batchStartRow0.qualifyColumn('farm_id'), batchStartRow.qualifyColumn('farm_id'))
                  .whereColumn(batchStartRow0.qualifyColumn('pond_id'), '!=', batchStartRow.qualifyColumn('pond_id'))
                  .where((query1: Builder) => query1.whereColumn(batchStartRow0.qualifyColumn('started_at'), '<', batchStartRow.qualifyColumn('started_at'))
                    .orWhere((query2: Builder) => query2.whereColumn(batchStartRow0.qualifyColumn('started_at'), '=', batchStartRow.qualifyColumn('started_at'))
                      .whereColumn(batchStartRow0.getQualifiedKeyName(), '<', batchStartRow.getQualifiedKeyName())))
                  .whereColumn(
                    batchStartRow0.qualifyColumn('started_at'),
                    '>=',
                    new Expression(`date(${batchStartRow.qualifyColumn('started_at')}, ('-' || ${batchStartRow.qualifyColumn('batch_margin')} || ' day'))`)
                  )
                  .toBase(),
                'and',
                true
              )
              .toSql()
          }) as number`),
          new Expression(`(${batchStart.qualifyColumn('farm_id')}) as farm_id`),
          new Expression(`(${batchStart.qualifyColumn('started_at')}) as start_batch`),
          new Expression(`(${batchStart.qualifyColumn('preparation_started_date')}) as preparation_started_date`)
        ])
        .table(new Cycle().getTable(), batchStart.getTable())
        .orderBy(batchStart.qualifyColumn('started_at'));
      const cycleBatchStart = new Cycle().setTable(`${batchStart.getTable()}_${new Cycle().getTable()}`);
      /** Where not exists */
      batchStartQuery.addWhereExistsQuery(
        Cycle.query().setModel(cycleBatchStart).withoutGlobalScopes(['join_batch'])
          .table(new Cycle().getTable(), cycleBatchStart.getTable())
          .whereColumn(cycleBatchStart.qualifyColumn('farm_id'), batchStart.qualifyColumn('farm_id'))
          .whereColumn(cycleBatchStart.qualifyColumn('pond_id'), '!=', batchStart.qualifyColumn('pond_id'))
          .where((query1: Builder) => query1.whereColumn(cycleBatchStart.qualifyColumn('started_at'), '<', batchStart.qualifyColumn('started_at'))
            .orWhere((query2: Builder) => query2.whereColumn(cycleBatchStart.qualifyColumn('started_at'), '=', batchStart.qualifyColumn('started_at'))
              .whereColumn(cycleBatchStart.getQualifiedKeyName(), '<', batchStart.getQualifiedKeyName())))
          .whereColumn(
            cycleBatchStart.qualifyColumn('started_at'),
            '>=',
            new Expression(`date(${batchStart.qualifyColumn('started_at')}, ('-' || ${batchStart.qualifyColumn('batch_margin')} || ' day'))`)
          )
          .toBase(),
        'and',
        true
      );
      const batchEnd = new Cycle().setTable('batches_end');
      const batchEndRow = new Cycle().setTable('batches_end_row');
      const batchEndRow0 = new Cycle().setTable('batches_end_row0');
      const batchEndQuery = Cycle.query().setModel(batchEnd).withoutGlobalScopes(['join_batch'])
        .select([
          new Expression(`(${
            Cycle.query().setModel(batchEndRow)
              .selectRaw('COUNT(*)')
              .table(new Cycle().getTable(), batchEndRow.getTable())
              .whereColumn(batchEndRow.qualifyColumn('farm_id'), batchEnd.qualifyColumn('farm_id'))
              .whereColumn(batchEndRow.qualifyColumn('started_at'), '<=', batchEnd.qualifyColumn('started_at'))
              .addWhereExistsQuery(
                Cycle.query().setModel(batchEndRow0).withoutGlobalScopes(['join_batch'])
                  .table(new Cycle().getTable(), batchEndRow0.getTable())
                  .whereColumn(batchEndRow0.qualifyColumn('farm_id'), batchEndRow.qualifyColumn('farm_id'))
                  .whereColumn(batchEndRow0.qualifyColumn('pond_id'), '!=', batchEndRow.qualifyColumn('pond_id'))
                  .where((query1: Builder) => query1.whereColumn(batchEndRow0.qualifyColumn('started_at'), '>', batchEndRow.qualifyColumn('started_at'))
                    .orWhere((query2: Builder) => query2.whereColumn(batchEndRow0.qualifyColumn('started_at'), '=', batchEndRow.qualifyColumn('started_at'))
                      .whereColumn(batchEndRow0.getQualifiedKeyName(), '>', batchEndRow.getQualifiedKeyName())))
                  .whereColumn(
                    batchEndRow0.qualifyColumn('started_at'),
                    '<=',
                    new Expression(`date(${batchEndRow.qualifyColumn('started_at')}, ('+' || ${batchEndRow.qualifyColumn('batch_margin')} || ' day'))`)
                  )
                  .toBase(),
                'and',
                true
              )
              .toSql()
          }) as number`),
          new Expression(`(${batchEnd.qualifyColumn('farm_id')}) as farm_id`),
          new Expression(`(${batchEnd.qualifyColumn('started_at')}) as end_batch`),
        ])
        .table(new Cycle().getTable(), batchEnd.getTable())
        .orderBy(batchEnd.qualifyColumn('started_at'));
      const cycleBatchEnd = new Cycle().setTable(`${batchEnd.getTable()}_${new Cycle().getTable()}`);
      /** Where not exists */
      batchEndQuery.addWhereExistsQuery(
        Cycle.query().setModel(cycleBatchEnd).withoutGlobalScopes(['join_batch'])
          .table(new Cycle().getTable(), cycleBatchEnd.getTable())
          .whereColumn(cycleBatchEnd.qualifyColumn('farm_id'), batchEnd.qualifyColumn('farm_id'))
          .whereColumn(cycleBatchEnd.qualifyColumn('pond_id'), '!=', batchEnd.qualifyColumn('pond_id'))
          .where((query1: Builder) => query1.whereColumn(cycleBatchEnd.qualifyColumn('started_at'), '>', batchEnd.qualifyColumn('started_at'))
            .orWhere((query2: Builder) => query2.whereColumn(cycleBatchEnd.qualifyColumn('started_at'), '=', batchEnd.qualifyColumn('started_at'))
              .whereColumn(cycleBatchEnd.getQualifiedKeyName(), '>', batchEnd.getQualifiedKeyName())))
          .whereColumn(
            cycleBatchEnd.qualifyColumn('started_at'),
            '<=',
            new Expression(`date(${batchEnd.qualifyColumn('started_at')}, ('+' || ${batchEnd.qualifyColumn('batch_margin')} || ' day'))`)
          )
          .toBase(),
        'and',
        true
      );
      const batch = new Batch().setTable(`${new Batch().getTable()}_temp`);
      const batchQuery = Cycle.query().setModel(batch).withoutGlobalScopes()
        .select([
          batch.getQualifiedKeyName(),
          batch.qualifyColumn('number'),
          batch.qualifyColumn('start_batch'),
          batch.qualifyColumn('farm_id'),
          batchEnd.qualifyColumn('end_batch'),
          batch.qualifyColumn('preparation_started_date')
        ])
        .table(new Expression(`(${batchStartQuery.toSql()}) as ${batch.getTable()}`))
        .leftJoin(new Expression(`(${batchEndQuery.toSql()}) as ${batchEnd.getTable()}`),
          (clause: QueryBuilder) => {
            clause.whereColumn(`${batch.getTable()}.farm_id`, `${batchEnd.getTable()}.farm_id`)
              .whereColumn(batch.qualifyColumn('number'), batchEnd.qualifyColumn('number'));
          });

      return batchQuery.toBase();
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression([
          `${this.getTable()}.*`,
          `${this.qualifyColumn('farm_id_start_batch')} as farm_id_start_batch`,
        ].join(', '));
      }
      if (column === 'farm_id_start_batch') {
        return new Expression(`(${this.qualifyColumn('farm_id')} || '-' || ${this.qualifyColumn('start_batch')})`);
      }
      return super.qualifyColumn(column);
    }

    relationFarm() {
      return Farm.query().whereKey(this.farm_id);
    }

    relationCycles() {
      const sql = this.constructor.renderSqlWithParams(Batch.query().toBase());
      const query = Cycle.query();
      query.select([
        query.qualifyColumn('*'),
        query.qualifyColumn('start_batch'),
        query.qualifyColumn('farm_id_start_batch')
      ])
      .leftJoin(`(${sql}) as cycles_batches`, (clause: QueryBuilder) => {
        clause.whereColumn(query.qualifyColumn('farm_id'), 'cycles_batches.farm_id')
          .whereColumn(query.qualifyColumn('started_at'), '>=', 'cycles_batches.start_batch')
          .whereColumn(query.qualifyColumn('started_at'), '<=', 'cycles_batches.end_batch')
      })
      .where(query.qualifyColumn('farm_id'), this.getAttribute('farm_id'))
      .where(query.qualifyColumn('start_batch'), this.getAttribute('start_batch'))
    }

    static fetch(params = {}) {
      if (Platform.OS === 'web')
        return this.createAxios().get(this.endpoint, {
          params: {
            per_page: 1000,
            ...params
          }
        }).then(({ data: { data } }) => {
            const synced_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
            return data.map((datum) => this.hydrate({...datum, id: (datum.id || '').replace('-', ','), synced_at}))
        })
      else {
        return super.fetch(params)
      }
    }
}
